import { useInsurancesOperations } from './useInsurancesOperations';
import { useInsuranceOperations } from './useInsuranceOperations';

export { useInsurancesOperations, useInsuranceOperations };
